module.exports = __webpack_public_path__ + "img/1_028.5154a00f.jpg";